<template>
  <TableColumnPrimary header=""
                      v-bind="attrs"
                      v-on="$listeners"
                      :rows="dummyRows"
                      :width="width">
    <template v-slot:row="props">
      <div :style="selectContainerStyle">
        <SelectPopoverPrimary v-bind="selectAttrs"
                              horizontalPosition="right"
                              :disableSelectState="true"
                              :options="options"
                              @select="optionIndex => $emit('select-action', optionIndex, props.index)">
          <template v-slot:select>
            <IconPrimary :content="iconContent" />
          </template>
        </SelectPopoverPrimary>
      </div>
    </template>
  </TableColumnPrimary>
</template>

<script>
  import IconPrimary from '@modules/icon/icon-primary'
  import SelectPopoverPrimary from '@modules/select/select-popover-primary'
  import TableColumnPrimary from '@modules/table/table-column-primary'

  export default {
    name: 'TablePopoverColumnPrimary',
    inheritAttrs: false,
    components: {
      IconPrimary,
      SelectPopoverPrimary,
      TableColumnPrimary,
    },
    props: {
      iconContent: { type: String, required: false, default: 'more_horiz' },
      options: { type: Array, required: false, default: () => [] },
      rowsLength: { type: Number, required: false, default: 0 },
      width: { type: String, required: false, default: '100%' },
    },
    data: function () {
      return {
        attrs: {},
        iconStyle: {},
        selectAttrs: {
          optionContainerStyle: {
            width: '200px',
          },
        },
        selectContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        ...this.$attrs,
      };

      this.iconStyle = {
        ...this.iconStyle,
        ...this.$attrs.iconStyle,
      };
    },
    computed: {
      dummyRows: function () {
        return new Array(this.rowsLength);
      },
    },
  };
</script>
